import { Component } from '@angular/core';
import { FORM_BUTTONS } from '../formulario/form-buttons.config';
import { FormButtonType } from '../formulario/formButtonType.enum';
import { FormularioComponent } from '../formulario/formulario.component';
import { Field } from '../formulario/field.model';
import { FunctionsAvailable, ItemType } from '../formulario/request.model';
import { FieldsForm } from '../formulario/data-fields';

@Component({
  selector: 'app-prueba-formulario',
  standalone: true,
  imports: [FormularioComponent],
  templateUrl: './prueba-formulario.component.html',
  styleUrl: './prueba-formulario.component.scss'
})
export class PruebaFormularioComponent {
  loading = true;
  typeForm = 'crear';
  item: ItemType = ItemType.ASOCIACIONES;
  buttons = [
    FORM_BUTTONS[FormButtonType.Borrar],
    FORM_BUTTONS[FormButtonType.Cancelar],
  ]

  titleForm = 'Formulario nuevo';
  functions: FunctionsAvailable[] = Object.values(FunctionsAvailable);
  functionSelected!: FunctionsAvailable;

  public fields: Field[] = [];

  constructor(
  ) {
    this.loading = true;
  }  

  public loadFormConfig(event: Event){

    const target = event.target as HTMLSelectElement;
    const selectedFunction = target.value as FunctionsAvailable;
    this.functionSelected = selectedFunction;
    this.assignTypeAndItemForm();
    this.loadButtons();
    this.loadFields();
    this.titleForm = `${this.typeForm} ${this.item}`;
    this.loading = false;
    /*
    if (this.typeForm === 'crear') {
      this.fields = [
        { name: 'id', type: 'number', value: '', label: 'Id' },
        { name: 'tipo_asociacion', type: 'number', value: '', label: 'Tipo de asociación' },
        { name: 'nombre', type: 'text', value: '', label: 'Nombre' },
        { name: 'lema', type: 'text', value: '', label: 'Lema' },
        { name: 'anyo_fundacion', type: 'text', value: '', label: 'Año de fundación' },
        { name: 'direc+cion', type: 'text', value: '', label: 'Dirección correo' },
        { name: 'telefono', type: 'text', value: '', label: 'Teléfono de contacto' },
        { name: 'email', type: 'text', value: '', label: 'e-mail' },
        { name: 'password', type: 'text', value: '', label: 'Contraseña' },
      ]
    } else {
      this.fields = [
        { name: 'id', type: 'number', value: '1', label: 'Id' },
        { name: 'tipo_asociacion', type: 'number', value: '1', label: 'Tipo de asociación' },
        { name: 'nombre', type: 'text', value: 'Prueba', label: 'Nombre' },
        { name: 'lema', type: 'text', value: 'Probando desde 1996 (sin debug)', label: 'Lema' },
        { name: 'anyo_fundacion', type: 'text', value: '1996', label: 'Año de fundación' },
        { name: 'direccion', type: 'text', value: 'Calle inventada 77', label: 'Dirección correo' },
        { name: 'telefono', type: 'text', value: '654654654', label: 'Teléfono de contacto' },
        { name: 'email', type: 'text', value: 'fran@prueba.es', label: 'e-mail' },
        { name: 'password', type: 'text', value: 'fran123', label: 'Contraseña' },
      ]
    }*/

  }

  assignTypeAndItemForm() {
    this.functionSelected.includes('Post') ? this.typeForm = 'crear' : this.typeForm = 'edit';
    let itemType: string = this.functionSelected.split('P')[0].toUpperCase();
    this.item = ItemType[itemType as keyof typeof ItemType];
  }

  loadButtons() {
    if (this.buttons.length === 3) {
      this.buttons.shift();
    }
    this.typeForm === 'crear' ? this.buttons.unshift(FORM_BUTTONS[FormButtonType.Crear]) : this.buttons.unshift(FORM_BUTTONS[FormButtonType.Editar]);
  }

  loadFields() {
    this.fields = FieldsForm[this.item];
  }

}
